import { gql } from "@apollo/client";

export const CREATE_DCDD_MEMBERSHIP_PLAN_PLAN = gql`
  mutation DcddCreateMembershipPlan(
    $end_date: Time!
    $membership_plan: String!
    $user_limit: Int!
    $remarks: String!
  ) {
    dcddCreateMembershipPlan(
      end_date: $end_date
      membership_plan: $membership_plan
      user_limit: $user_limit
      remarks: $remarks
    ) {
      data {
        user_membership {
          created_at
          end_date
          id
          join_date
          membership_plan
          remarks
          status
          updated_at
          user_limit
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;
export const UPDATE_DCDD_MEMBERSHIP_PLAN_PLAN = gql`
  mutation DcddUpdateMembershipPlan(
    $end_date: Time!
    $membership_plan: String!
    $user_limit: Int!
    $remarks: String!
    $user_membership_id: UUID!
  ) {
    dcddUpdateMembershipPlan(
      end_date: $end_date
      membership_plan: $membership_plan
      user_limit: $user_limit
      remarks: $remarks
      user_membership_id: $user_membership_id
    ) {
      data {
        user_membership {
          created_at
          end_date
          id
          join_date
          membership_plan
          remarks
          status
          updated_at
          user_limit
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;
export const UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_PLAN = gql`
mutation UpdateUserMembershipStatus($id:UUID!) {
    UpdateUserMembershipStatus(id: $id) {
        error {
            message
            code
            field
        }
        data {
            user_membership {
                user_limit
                updated_at
                end_date
                join_date
                created_at
                membership_plan
                status
                id
                remarks
            }
        }
    }
}

`;
